import { useFormik } from "formik";
import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Toast, ToastContainer } from "react-bootstrap";
import { createStateApi, updateStateApi } from "./states-list/core/_requests";
import { useQueryResponse } from "./states-list/core/QueryResponseProvider";

type Props = {
  isEditing: boolean
  id: any
  handleClose: () => void
}

const AddEditState = ({isEditing, id, handleClose}: Props) => {
  const {refetch} = useQueryResponse()
  const [isLoading,setIsLoading] = useState(false)
  const [isSuccess,setIsSuccess] = useState(false)
  const [showError,setShowError] = useState(false)
  const [sessionMessage, setSessionMessage] = useState({
    type: '',
    message: '',
    show: false,
  })

  const validate = (values:any) => {
    const errors = {} as any;
    if(!values.name){
      errors.name = "The name field is required"
    }
    return errors
  };

  const addEditAction = async (values:any) => {
    try{
      setIsLoading(true)
      if(isEditing){
        var response = await updateStateApi(id,values)
      }
      else{
        var response = await createStateApi(values)
      }
      if(response.responseStatus == 200){
        refetch()
        setSessionMessage({type: 'success',message: response.responseMessage ,show: true})      
        if(isEditing){
          setIsSuccess(true)
          setTimeout(()=>{
            handleClose()
            setIsLoading(false)
            setIsSuccess(false)
          },1500)
        }
        else{
          formik.setFieldValue("name","")
          formik.setFieldError("name","")
          setIsLoading(false)
        }
        setShowError(false)
      }
      else{
        setSessionMessage({type: 'danger',message: response.responseMessage ,show: true})
        setIsLoading(false)
      }
    }
    catch(err:any){
      let message = err?.message ? err.message : err?.responseMessage ? err.responseMessage : "Something went wrong" as any
      setSessionMessage({type: 'danger',message: message ,show: true})
      setIsLoading(false)
    }
  }

  useEffect(()=>{
    setTimeout(()=>{
      setSessionMessage({type: '',message: '',show: false})
    },3000)
  },[sessionMessage.show])

  const formik = useFormik({
    validate,
    initialValues: {
      name: '',
      status: 1,
    },
    onSubmit: values => {
      addEditAction(values)
    },
  });

  // Prevent form submission from refreshing the page
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    formik.handleSubmit()
  }

  return (
    <>
      <Form noValidate className='border-end mt-6 p-5' id='kt_modal_add_user_form' onSubmit={handleSubmit}>
        <h4 className='card-label font-weight-bolder text-dark font-size-h5 mb-6'>
          {' '}
          {isEditing ? "Edit State" : "Add State"}
        </h4>
        <Row className='mb-7'>
          <Col>
            <Form.Group>
              <Form.Label className='required fw-bold fs-6 mb-1 form-label'>
                State Name
              </Form.Label>
              <Form.Control type='text' 
                className='form-control form-control-solid mb-lg-0' 
                placeholder="State Name"
                onChange={(e:any)=>{
                  formik.setFieldValue("name",e.target.value.trimStart())
                }}
                value={formik.values.name} 
              />
              <p className="text-danger mt-2">{showError ? formik.errors.name : ""}</p>
            </Form.Group>
          </Col>
        </Row>
        <Row className='mb-7'>
          <Col>
            <Form.Group>
              <Button
                type='submit'
                onClick={()=>{
                  setShowError(true)
                }}
                className='btn btn-primary font-weight-bold mr-2 btn-block'
                data-kt-users-modal-action='submit'
                disabled={isLoading || isSuccess}
              >
                <span className='indicator-label'>{isLoading ? "Please Wait..." : "Save"}</span>
              </Button>
            </Form.Group>
          </Col>
        </Row>
        <ToastContainer className='p-3 position-fixed' position={'top-center'}>
          <Toast
            show={sessionMessage.show}
            bg={sessionMessage.type}
          >
            <Toast.Body className='text-white'>{sessionMessage.message}</Toast.Body>
          </Toast>
        </ToastContainer>
      </Form>
    </>
  )
}

export default AddEditState 